import SystemErrorDescription from './SystemErrorDescription';

export default SystemErrorDescription;
